import React, { useEffect, useState } from "react";
import { PrimaryButton } from "../../../Components/Cta";
import { SelectInput } from "../../../Components/FormElements";
import { CustomSelectBox } from "../../../Components/DropDown";

const BASKET_OPTIONS = [
  { label: "Wealth Builder", value: "wealth" },
  { label: "Balanced Edge", value: "balanced" },
  { label: "Tax Saver", value: "tax" },
];

export default function Stage3({ setTitle, updateData, changePage }) {
  const [selectedOption, setSelectedOption] = useState("");
  const [citizenship, setCitizenship] = useState(null);
  const [occupation, setOccupation] = useState(null);
  const [taxResident, setTaxResident] = useState("");
  const [politicallyExposed, setPoliticalyExposed] = useState("");
  const [income, setIncome] = useState("");

  const [errors, setErrors] = useState({});

  useEffect(() => {
    setTitle("Personal details");
  }, [setTitle]);

  const validate = () => {
    const newErrors = {};
    if (!selectedOption)
      newErrors.selectedOption = "Please select marital status.";
    if (!citizenship)
      newErrors.citizenship = "Please select your citizenship.";
    if (!taxResident) newErrors.taxResident = "Please select an option.";
    if (!politicallyExposed)
      newErrors.politicallyExposed = "Please select an option.";
    if (!occupation)
      newErrors.occupation = "Please select your occupation.";
    if (!income) newErrors.income = "Please select your annual income.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validate()) {
      updateData((prev) => ({
        ...prev,
        selectedOption,
        citizenship,
        occupation,
        taxResident,
        politicallyExposed,
        income,
      }));
      changePage(4);
    }
  };

  return (
    <div className="row row-gap-4">
      <div className="col-12 d-flex flex-column">
        <div className="p-3 d-flex flex-column row-gap-3 mt-1 e-bg-ghost-white-dark e-border-radius-16 e-border-1px-pale-lavender">
          <SelectInput
            label="Marital status"
            require
            value={selectedOption}
            onSelect={(val) => {
              setSelectedOption(val);
              setErrors((prev) => ({ ...prev, selectedOption: "" }));
            }}
            options={["Single", "Married"]}
            error={errors.selectedOption}
          />

          <h5 className="e-primary-font-poppins e-font-weight-500 e-font-16 pt-2">
            Nationality & tax
          </h5>

          {/* Citizenship */}
          <CustomSelectBox
            label="Citizenship"
            placeholder="Add Citizenship"
            labelClass="e-text-black e-primary-font-poppins e-font-16 e-font-weight-400 line-height-20px mb-2"
            require
            type={4}
            options={BASKET_OPTIONS}
            value={citizenship}
            selectChange={(val) => {
              setCitizenship(val);
              setErrors((prev) => ({ ...prev, citizenship: "" }));
            }}
            isSearchable={false}
            error={errors.citizenship}
            isClearable={false}
          />

          <SelectInput
            label="Are you a tax-paying resident in any other country?"
            value={taxResident}
            onSelect={(val) => {
              setTaxResident(val);
              setErrors((prev) => ({ ...prev, taxResident: "" }));
            }}
            options={["Yes", "No"]}
            error={errors.taxResident}
          />

          <SelectInput
            label="Are you a politically exposed person?"
            value={politicallyExposed}
            onSelect={(val) => {
              setPoliticalyExposed(val);
              setErrors((prev) => ({ ...prev, politicallyExposed: "" }));
            }}
            options={["Yes", "No"]}
            error={errors.politicallyExposed}
          />

          <h5 className="e-primary-font-poppins e-font-weight-500 e-font-16 ">
            Occupation details
          </h5>

          {/* Occupation */}
          <CustomSelectBox
            label="Occupation"
            placeholder="Add occupation"
            labelClass="e-text-black e-primary-font-poppins e-font-16 e-font-weight-400 line-height-20px mb-2"
            require
            type={4}
            options={BASKET_OPTIONS}
            value={occupation}
            selectChange={(val) => {
              setOccupation(val);
              setErrors((prev) => ({ ...prev, occupation: "" }));
            }}
            isSearchable={false}
            error={errors.occupation}
            isClearable={false}
          />

          <SelectInput
            label="What is your annual income?"
            value={income}
            onSelect={(val) => {
              setIncome(val);
              setErrors((prev) => ({ ...prev, income: "" }));
            }}
            options={[
              "Below ₹1L",
              "₹1L - ₹5L",
              "₹1L - ₹10L",
              "₹10L - ₹25L",
              "Above ₹25L",
            ]}
            error={errors.income}
          />
        </div>
      </div>

      {/* CTA Buttons */}
      <div className="col-lg-10 offset-lg-2 col-12">
        <div className="row">
          <div className="col-6">
            <PrimaryButton
              ClassName="e-border-radius-pill e-border-1px-blue py-3 e-font-weight-500 e-font-16 w-100 bg-transparent e-text-blue-violet e-primary-font-poppins"
              name="Go back"
              onPress={() => changePage(2)}
            />
          </div>
          <div className="col-6">
            <PrimaryButton
              ClassName="e-border-radius-pill e-font-weight-500 py-3 e-font-16 w-100 e-bg-blue-violet text-white e-primary-font-poppins"
              name="Continue"
              onPress={handleSubmit}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
